import { __decorate } from "tslib";
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { Angulartics2Module } from 'angulartics2';
import { TrackingChangeConsentButtonComponent } from './change-consent';
import { MatomoInjector } from './matomo-injector.service';
import { TrackingConsentComponent } from './tracking-consent/tracking-consent.component';
import * as i0 from "@angular/core";
import * as i1 from "angulartics2";
let TrackingFrontendFeature = /*#__PURE__*/(() => {
  let TrackingFrontendFeature = class TrackingFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/tracking/frontend","featureId":"common-tracking"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: TrackingConsentComponent,
        excludeSSR: true,
        inputs: {
          position: 'overlay'
        }
      }]);
      functionality.defineWidgets([{
        type: 'Content',
        id: 'TrackingChangeConsentButtonComponent',
        positionIds: ['common/cms/data-privacy-top'],
        component: TrackingChangeConsentButtonComponent
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵTrackingFrontendFeature_BaseFactory;
        return function TrackingFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵTrackingFrontendFeature_BaseFactory || (ɵTrackingFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(TrackingFrontendFeature)))(__ngFactoryType__ || TrackingFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: TrackingFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [MatomoInjector],
        imports: [Angulartics2Module.forRoot({}), TrackingConsentComponent]
      });
    }
  };
  TrackingFrontendFeature = __decorate([ClassName("TrackingFrontendFeature")], TrackingFrontendFeature);
  return TrackingFrontendFeature;
})();
export { TrackingFrontendFeature };